import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import PlanningPage from "@/pages/PlanningPage";
import IntermittentsPage from "@/pages/IntermittentsPage";
import StaffPage from "@/pages/StaffPage";
import OuvreusesPage from "@/pages/OuvreusesPage";
import RegistrationPage from "@/pages/RegistrationPage";
import OuvreuseRegistrationPage from "@/pages/OuvreuseRegistrationPage";
import CompleterEquipesPage from "@/pages/CompleterEquipesPage";
import StatsPage from "@/pages/StatsPage";
import SalairesPage from "@/pages/SalairesPage";
import ConcertDetailPage from "@/pages/ConcertDetailPage";
import SynthesePage from "@/pages/SynthesePage";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/inscription" element={<RegistrationPage />} />
            <Route path="/inscription-ouvreuse" element={<OuvreuseRegistrationPage />} />
            <Route path="/completer-equipes/:token" element={<CompleterEquipesPage />} />
            <Route path="/" element={<Protected><PlanningPage /></Protected>} />
            <Route path="/intermittents" element={<Protected><IntermittentsPage /></Protected>} />
            <Route path="/staff" element={<Protected><StaffPage /></Protected>} />
            <Route path="/ouvreuses" element={<Protected><OuvreusesPage /></Protected>} />
            <Route path="/stats" element={<Protected><StatsPage /></Protected>} />
            <Route path="/salaires" element={<Protected><SalairesPage /></Protected>} />
            <Route path="/concerts/:id" element={<Protected><ConcertDetailPage /></Protected>} />
            <Route path="/concerts/:id/synthese" element={<Protected><SynthesePage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
